import { Types } from '../actions/productHistoryActions';

const initialState = {
  loading: true,
  error: '',
  data: [],
};

export const productHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.GET_PRODUCT_HISTORY_REQUEST: {
      return {
        ...state,
        data: [],
        loading: true,
      };
    }
    case Types.RESET_PRODUCT_HISTORY: {
      return {
        ...initialState,
        loading: false,
      };
    }

    case Types.GET_PRODUCT_HISTORY_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    }
    case Types.SET_ERROR: {
      return {
        ...state,
        ...action.payload,
        data: [],
        loading: false
      };
    }
    default:
      return state;
  }
};
